export default __webpack_public_path__ + "static/media/Step 3 - custom image upload modal.6d2a5f85.jpg";